module.exports = __webpack_public_path__ + "img/user-profile.c0c842e3.png";